import { render, staticRenderFns } from "./RussianTrade.vue?vue&type=template&id=7dc41340&scoped=true"
import script from "./RussianTrade.vue?vue&type=script&lang=js"
export * from "./RussianTrade.vue?vue&type=script&lang=js"
import style0 from "./RussianTrade.vue?vue&type=style&index=0&id=7dc41340&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc41340",
  null
  
)

export default component.exports